<div class="content">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    @for (link of navLinks(); track link) {
      <a #rla="routerLinkActive" [active]="rla.isActive" [routerLink]="link.path"
        mat-tab-link
        routerLinkActive>
        @if (!link.image) {
          <span>
            {{ link.path === 'unitList' ? link.label + ' (' + unitListSize() + ')' : link.label }}
          </span>
        }
        @if (link.image) {
          <span>
            <img [src]="link.image" [alt]="link.path" class="linkImage"/>
            <label class="imageSuffix">{{ link.label }}</label>
          </span>
        }
      </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
